import "./DetailSearchStyle.scss";
import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { PublicController } from "../../../ajax/PublicController";
import { debounce } from "../../../helper/debounce";
import { LoadingComponent, InputComponent, DateComponent, NumberComponent, CheckBoxComponent, ButtonComponent, OverlayComponent, SelectComponent, EventHandler } from "jsl-ui";
import { DropDownComponent } from "jsl-ui/lib/components/drop-down/DropDownComponent";
import { StackPanelComponent } from "../../components/layout/StackPanelComponent";
import { FundListComponent } from "../../components/FundListComponent";
import { LookupInfo } from "../../../ajax/types/LookupInfo";
import { LongLatC, MapComponent } from "../../components/map/MapComponent";
import { FundDetailsDTO } from "../../../ajax/types/FundDetailsDTO";
import { SearchDetailsParam } from "../../../ajax/types/SearchDetailsParam";

const MAX_RETURNED_RESULTS = 1000;

export class DetailSearchComponent implements IJSLComponent {

    private data: FundDetailsDTO[] = [];
    private resultGrid: FundListComponent;
    private term: string = "";
    private map: MapComponent;
    public lastFilter: SearchDetailsParam;

    private filterComp: FilterComponent;
    private filterOverlay: OverlayComponent;

    // TODO: MeerHoeheVon MeerHoeheBis


    private searchDebounced = debounce((evt) => {
        return;
    }, 800);
    // private searchDebounced = debounce((evt) => {
    //     if (!evt.target.classList.contains("search-in-input")) {
    //         return;
    //     }
    //     this.search();
    // }, 800);

    public constructor() {
        this.resultGrid = new FundListComponent(null, true);
        this.filterComp = new FilterComponent();
        this.filterComp.onStartSearch.subscribe(() => {
            this.search();
            this.filterOverlay.close();
        });
        PublicController.GetFilterValues().then((lookups) => {
            this.filterComp.lookups = lookups;
            // this.init();
            refresh();
        });
    }

    private initFilters() {
        let g = this.filterComp.lookups.gemeinden._select((el) => el.bundesland)._distinct();
        g.splice(0, 0, null);
        this.filterComp.bundesland = new SelectComponent({
            // defaultSelected: false,
            data: g.map((x) => ({ value: x ?? "", text: x ?? "- alle -" })),
            onChange: ((val) => { this.fillBezirke(val as string); /*this.search();*/ }),
            // placeholder: "Bundesland",
            class: "my-inline",
            // width: "10rem",
            value: this.lastFilter?.bundesland
        });

        g = this.filterComp.lookups.roteListe;
        g.splice(0, 0, null);
        this.filterComp.roteListe = new SelectComponent({
            data: g.map((x) => ({ value: x ?? "", text: x ?? "- alle -" })),
            // onSelect: (() => { /*this.search();*/ }),
            class: "my-inline",
            // width: "10rem",
            value: this.lastFilter?.roteList
        });

        // g = this.filterComp.lookups.familie;
        // g.splice(0, 0, null);
        // this.filterComp.familie = new DropDownComponent({
        //     data: g.map((x) => ({ value: x ?? "", text: x ?? "- alle -" })),
        //     onSelect: (() => { /*this.search();*/ }),
        //     class: "my-inline",
        //     width: "10rem",
        //     value: this.lastFilter?.familie
        // });

        // g = this.filterComp.lookups.pilzgruppe;
        // g.splice(0, 0, null);
        // this.filterComp.pilzgruppe = new DropDownComponent({
        //     data: g.map((x) => ({ value: x ?? "", text: x ?? "- alle -" })),
        //     onSelect: (() => { /*this.search();*/ }),
        //     class: "my-inline",
        //     width: "10rem",
        //     // value: this.lastFilter?.pil
        // });

        this.filterComp.sammler = new InputComponent({ type: "text", class: "search-in-input", value: this.lastFilter?.sammler });
        this.filterComp.bestimmer = new InputComponent({ type: "text", class: "search-in-input", value: this.lastFilter?.bestimmer });
        this.filterComp.substrat = new InputComponent({ type: "text", class: "search-in-input", value: this.lastFilter?.substrat });

        this.filterComp.quadrant = new NumberComponent({ format: "0", class: "search-in-input", style: "width:95%", value: this.lastFilter?.quadrant });

        this.filterComp.fundDatumFrom = new DateComponent({ class: "date-in-input", value: this.lastFilter?.datumFrom });
        this.filterComp.fundDatumTo = new DateComponent({ class: "date-in-input", value: this.lastFilter?.datumTo });
        this.filterComp.fundDatumFrom.onChange.subscribe(() => {
            /*this.search();*/
        });
        this.filterComp.fundDatumTo.onChange.subscribe(() => {
            /*this.search();*/
        });

        const valueList = [{ value: "", text: "-" }];

        for (let i = 100; i <= 3000; i += 100) {
            valueList.push({ value: i.toString(), text: i.toString() });
        }
        this.filterComp.hoeheFrom = new DropDownComponent({
            data: valueList,
            searchable: false,
            class: "my-inline",
            width: "8rem",
            onSelect: (() => { /*this.search();*/ }),
            value: this.lastFilter?.hoeheFrom.toString()
        });
        this.filterComp.hoeheTo = new DropDownComponent({
            data: valueList,
            searchable: false,
            class: "my-inline",
            width: "8rem",
            onSelect: (() => { /*this.search();*/ }),
            value: this.lastFilter?.hoeheTo.toString()
        });
        this.filterComp.onlyWithImages = new CheckBoxComponent({
            label: "mit Bild",
            value: this.lastFilter?.onlywithimages
        });
        this.filterComp.datenquelle = new InputComponent({ class: "search-in-input", value: this.lastFilter?.datenquelle });
        this.filterComp.herbarPriv = new InputComponent({ class: "search-in-input", value: this.lastFilter?.herbarPriv });
        this.filterComp.herbarOeff = new InputComponent({ class: "search-in-input", value: this.lastFilter?.herbarOeff });
        refresh();
    }



    public render(): IJSLVNode {
        if (this.filterComp.lookups == null) {
            return <section class="banner-area"><div class="container">{new LoadingComponent()}</div></section>;
        }

        return <div><div id="side-nav">Hallo</div><section class="banner-area detail-search-comp" input={this.searchDebounced}>
            <div style="text-align:right;">
                <a style="width:20rem;max-width:80vw" class="genric-btn default-border search-btn" href="#">
                    <span>zur einfachen Suche wechseln</span>
                </a>
            </div>

            <div style="text-align:center">
                <span style="margin-right:1rem;display:inline-block;">Pilztaxon oder Name:</span>
                <input id="tb-search" class="search-in-input" type="text" style="max-width:80vw;text-align:left;width:20rem;" />
            </div>
            {/* <div class="container">
                <div class="row justify-content-between mb-10">
                    <div class="col-4 col-md-3">
                        <div style="text-align:center">Pilztaxon oder Name:</div>
                    </div>
                    <div class="col-8 col-md-6" style="text-align:right;">
                        <input id="tb-search" class="search-in-input" type="text" style="width:90%;text-align:left;" />
                    </div>
                </div>
            </div> */}
            <div class="filter-box">
                <button class="genric-btn primary" click={() => {
                    this.initFilters();
                    this.filterOverlay = OverlayComponent.show({
                        content: this.filterComp,
                    });
                }}>Filtern</button> <button class="genric-btn primary" id="button-start-search" click={() => { this.search(); }}>Suche starten</button>
            </div>
            {this.resultGrid.countRows() === MAX_RETURNED_RESULTS ?
                <p style="margin:0.2rem"><i>* für weitere Ergebnisse bitte Such-Kriterien einschränken</i></p> : null}
            {this.resultGrid}
            <div class="map-comp">
                {this.map}
            </div>
        </section></div>;
    }

    public onCreate() {
        const tbSearch = (document.getElementById("tb-search") as HTMLInputElement);
        if (tbSearch != null) {
            tbSearch.value = this.term;
        }
    }

    private fillBezirke(bundesland: string) {
        this.filterComp.gemeinde = null;
        const g = this.filterComp.lookups.gemeinden._where((el) => el.bundesland === bundesland)._select((el) => el.bezirk)._distinct();
        g.splice(0, 0, null);
        this.filterComp.bezirk = new SelectComponent({
            // defaultSelected: false,
            data: g.map((x) => ({ value: x ?? "", text: x ?? "- alle -" })),
            onChange: ((val) => { this.fillGemeinden(bundesland, val as string); /*this.search();*/ }),
            // placeholder: "Bezirk",
            // width: "10vw",
            class: "my-inline"
        });
        refresh();
    }

    private fillGemeinden(bundesland: string, bezirk: string) {
        const g = this.filterComp.lookups.gemeinden._where((el) => el.bundesland === bundesland && el.bezirk === bezirk)._select((el) => el.gemeinde)._distinct();
        g.splice(0, 0, null);
        this.filterComp.gemeinde = new SelectComponent({
            // defaultSelected: false,
            data: g.map((x) => ({ value: x ?? "", text: x ?? "- alle -" })),
            // onSelect: ((val) => { /*this.search();*/ }),
            // placeholder: "Gemeinde",
            // width: "10vw",
            class: "my-inline"
        });
        refresh();
    }

    private async search(): Promise<void> {
        this.term = (document.getElementById("tb-search") as HTMLInputElement).value;
        // const group = this.filterComp.pilzgruppe?.getRef()?.getValue() as string;
        // const familie = this.filterComp.familie?.getRef()?.getValue() as string;
        const roteList = this.filterComp.roteListe?.getValue() as string;
        const bundesland = this.filterComp.bundesland?.getValue() as string;
        const bezirk = this.filterComp.bezirk?.getValue() as string;
        const gemeinde = this.filterComp.gemeinde?.getValue() as string;
        const bestimmer = this.filterComp.bestimmer?.getValue();
        const sammler = this.filterComp.sammler?.getValue();
        const substrat = this.filterComp.substrat?.getValue();
        const datumFrom = this.filterComp.fundDatumFrom?.getValueAsDate();
        const datumTo = this.filterComp.fundDatumTo?.getValueAsDate();
        const hoeheFrom = parseInt(this.filterComp.hoeheFrom?.getRef().getValue() as string, 10);
        const hoeheTo = parseInt(this.filterComp.hoeheTo?.getRef().getValue() as string, 10);
        const quadrant = this.filterComp.quadrant?.getValueAsNumber() || null;
        const onlywithimages = this.filterComp.onlyWithImages?.getValue();
        const datenquelle = this.filterComp.datenquelle?.getValue();
        const herbarPriv = this.filterComp.herbarPriv?.getValue();
        const herbarOeff = this.filterComp.herbarOeff?.getValue();

        this.lastFilter = {
            name: this.term,
            // group,
            // familie,
            roteList,
            bundesland,
            bezirk,
            gemeinde,
            bestimmer,
            sammler,
            hoeheFrom,
            hoeheTo,
            substrat,
            datumFrom,
            datumTo,
            quadrant,
            onlywithimages,
            datenquelle,
            herbarPriv,
            herbarOeff
        };
        const promise = PublicController.SearchDetails(this.lastFilter);
        this.resultGrid.setData(promise);
        promise.then((funde) => {
            this.data = funde;
            const longLat: LongLatC[] = [];
            this.data.forEach((fund) => {
                if (fund.latitude != null && fund.longitude != null) {
                    longLat.push({ lon: fund.longitude, lat: fund.latitude, verschleiert: false }); // fund.koordinatenVerschleiert });
                }
            });
            this.map = new MapComponent(longLat, { height: "90rem", maxWidth: "30rem", defaultZoom: 6 });
            refresh();
        });
    }
}

class FilterComponent implements IJSLComponent {


    public lookups: LookupInfo;
    public bundesland: SelectComponent;
    public bezirk: SelectComponent;
    public gemeinde: SelectComponent;
    public roteListe: SelectComponent;
    // public familie: DropDownComponent;
    // public pilzgruppe: DropDownComponent;

    public sammler: InputComponent;
    public bestimmer: InputComponent;
    public substrat: InputComponent;

    public fundDatumFrom: DateComponent;
    public fundDatumTo: DateComponent;

    public quadrant: NumberComponent;

    public hoeheFrom: DropDownComponent;
    public hoeheTo: DropDownComponent;

    public onlyWithImages: CheckBoxComponent;
    public datenquelle: InputComponent;
    public herbarPriv: InputComponent;
    public herbarOeff: InputComponent;

    public onStartSearch = EventHandler.Create(null);

    public render(): IJSLVNode {
        return <div >
            <div style="position:absolute;overflow:auto;bottom:3rem;top:2.3rem;left:0;right:0;">
                <h3 style="color: black">Filter</h3>
                <div class="dialog-line">
                    <span>Rote Liste</span><br />
                    {this.roteListe}
                </div>
                <div class="dialog-line">
                    <span>Bundesland</span><br />
                    <div style="display:inline-block">{this.bundesland}</div>
                </div>
                {this.bezirk != null ?
                    <div class="dialog-line">
                        <span>Bezirk</span><br />
                        <div style="display:inline-block">{this.bezirk}</div>
                    </div> : <div></div>}
                {this.gemeinde != null ?
                    <div class="dialog-line">
                        <span>Gemeinde</span><br />
                        <div style="display:inline-block">{this.gemeinde}</div>
                    </div> : <div></div>}
                <div class="dialog-line">
                    <span>Sammler</span>
                    {this.sammler}
                </div>
                <div class="dialog-line">
                    <span>Bestimmer</span>
                    {this.bestimmer}
                </div>
                <div class="dialog-line">
                    <span>Substrat</span>
                    {this.substrat}
                </div>
                <div class="dialog-line">
                    <span>Quadrant</span>
                    {this.quadrant}
                </div>
                <div class="dialog-line">
                    <span>Funddatum</span><br />
                    <span>von </span>
                    {this.fundDatumFrom}
                    <span> bis </span>
                    {this.fundDatumTo}
                </div>
                <div class="dialog-line">
                    <span>Meereshöhe</span><br />
                    <span>von </span>
                    {this.hoeheFrom}
                    <span> bis </span>
                    {this.hoeheTo}
                </div>
                <div class="dialog-line">
                    <span>Datenquelle</span>
                    {this.datenquelle}
                </div>
                <div class="dialog-line">
                    <span>Herbar privat</span>
                    {this.herbarPriv}
                </div>
                <div class="dialog-line">
                    <span>Herbar öffentlich</span>
                    {this.herbarOeff}
                </div>
                <div class="dialog-line">
                    {this.onlyWithImages}
                </div>
            </div>
            {/* <div style="min-height: 3rem; max-height: 5rem; height: 15vw"></div> */}
            <div style="position: absolute; bottom: 0; left:0;right:0; text-align:center;z-index:10;background:white;">
                <button class="genric-btn primary" click={() => {
                    this.onStartSearch.notify();
                    // const btn = document.getElementById("button-start-search");
                    // btn.click();               
                }}>Suche starten</button>
            </div>
        </div>;
    }
}